import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

import { GroupsEvent } from '../GroupsEvent';

export class UserWasBanned extends GroupsEvent {
  process() {
    const { groupId } = this.eventPayload;
    const group = Entities.GroupsStore.getGroupById(groupId.toString());
    if (!group) {
      return;
    }

    let alert = {
      text: t('you_were_banned_alert').replace('{0}', group.name || ''),
      primaryText: t('common_ok'),
    };
    if (group.isChannel) {
      alert = t('banned_user_deeplink_error');
    }

    Tasks.group.removeGroupLocally({
      groupId: group.id,
      alert: { text: alert, primaryText: t('common_ok') },
    });
  }
}
